/*------------------------------------------------------------------
[React]
-------------------------------------------------------------------*/
import React, {useState} from "react";
/*------------------------------------------------------------------
[End React]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[React Helmet]
-------------------------------------------------------------------*/
import {Helmet} from "react-helmet";
/*------------------------------------------------------------------
[End React Helmet]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[API]
-------------------------------------------------------------------*/
import { API_GET_PUBLIC } from '../../api';
/*------------------------------------------------------------------
[End API]
-------------------------------------------------------------------*/

const Screen = ({loading, error}) => {

    const [name, set_name] = useState('');

    const [email, set_email] = useState('');

    const [message, set_message] = useState('');

    const _request = () => {
        
        loading(true);

        API_GET_PUBLIC(`client/mail__________?name=${name}&email=${email}&message=${message}`)
        .then((response) => {
            console.log('mail', response.data)
            if(response.data.result === 'success'){
                loading(false)
                error('Berhasil Mengirim Pesan')
                set_name('')
                set_email('')
                set_message('')
            }else if(response.data.error){
                error(response.data.error)
            }
        })
        .catch((e) => {
            console.log('catch : ', e)
            error(e.message)
        }).finally(() => {
            loading(false)
        })

    }

	return (
		<>
            <Helmet>

                <meta name="description" content={'Mail'}/>
                <title>{'Mail'}</title>

            </Helmet>

            <div className="_container">
                <div className="_lily_pad_h_d __section_pages_title">
                    <h1>Message</h1>
                </div>
            </div>
            <div className="_container">
                <div className="_row_auto">
                    <div className="_column_auto">
                        <input
                            className="__input" 
                            placeholder={'Nama'} 
                            onChange={e => set_name(e.target.value)}
                            value={name}
                        />
                        <br/>
                        <input
                            className="__input" 
                            type={'email'}
                            placeholder={'Email'} 
                            onChange={e => set_email(e.target.value)}
                            value={email}
                        />
                    </div>
                    <div className="_column_auto_2">
                        <textarea
                            className="__textarea"
                            placeholder={'Pesan'}  
                            onChange={e => set_message(e.target.value)}
                            value={message}>

                        </textarea>
                    </div>
                </div>
                <div className="_lily_pad_h_d">
                    <a className="_btn" onClick={() => _request()} style={{cursor: "pointer"}}>
                        Kirim
                    </a>
                </div>
            </div>
            <br/>
        </>
	);
}

export default Screen;